var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-scan"},[_c('div',{staticClass:"scan-box"},[_c('video',{ref:"video",staticClass:"scan-video",attrs:{"id":"video","autoplay":""}}),_vm._m(0),_c('div',{staticClass:"scan-tip"},[_vm._v(_vm._s(_vm.scanTextData.tipMsg))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-scanner"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"angle"})])])
}]

export { render, staticRenderFns }